function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.41667 2.5C7.41667 2.08579 7.08088 1.75 6.66667 1.75C6.25245 1.75 5.91667 2.08579 5.91667 2.5V3.41667H5.5C3.42893 3.41667 1.75 5.0956 1.75 7.16666V14.5C1.75 16.5711 3.42893 18.25 5.5 18.25H14.5C16.5711 18.25 18.25 16.5711 18.25 14.5V7.16667C18.25 5.0956 16.5711 3.41667 14.5 3.41667H14.0833V2.5C14.0833 2.08579 13.7475 1.75 13.3333 1.75C12.9191 1.75 12.5833 2.08579 12.5833 2.5V3.41667H7.41667V2.5ZM12.5833 5.83333V4.91667H7.41667V5.83333C7.41667 6.24755 7.08088 6.58333 6.66667 6.58333C6.25245 6.58333 5.91667 6.24755 5.91667 5.83333V4.91667H5.5C4.25736 4.91667 3.25 5.92402 3.25 7.16666V7.58333H16.75V7.16667C16.75 5.92403 15.7426 4.91667 14.5 4.91667H14.0833V5.83333C14.0833 6.24755 13.7475 6.58333 13.3333 6.58333C12.9191 6.58333 12.5833 6.24755 12.5833 5.83333ZM16.75 9.08333H3.25V14.5C3.25 15.7426 4.25736 16.75 5.5 16.75H14.5C15.7426 16.75 16.75 15.7426 16.75 14.5V9.08333Z",
  fill: "#676773"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.47204442.svg";
export { ForwardRef as ReactComponent };